import React from "react";
import { FlutterWaveButton, closePaymentModal } from "flutterwave-react-v3";
import { useGlobalContext } from "../InsuranceContext";

export default function App() {
  const { nextStep } = useGlobalContext();
  const config = {
    public_key: "FLWPUBK_TEST-3313a01e4710c2cb22845684f07a24a7-X",
    tx_ref: Date.now(),
    amount: 10000,
    currency: "NGN",
    payment_options: "card,mobilemoney,ussd",
    customer: {
      email: "user@gmail.com",
      phonenumber: "07064586146",
      name: "joel ugwumadu",
    },
    customizations: {
      title: "Anambra Insurance",
      description: "Payment for items in cart",
      logo: "https://st2.depositphotos.com/4403291/7418/v/450/depositphotos_74189661-stock-illustration-online-shop-log.jpg",
    },
  };

  const fwConfig = {
    ...config,
    text: "Make Payment!",
    callback: (response) => {
      console.log(response);
      closePaymentModal(); // this will close the modal programmatically
      // window.location.href = "/confirm";
      nextStep();
    },
    onClose: () => {},
  };

  return (
    <div className="App">
      <FlutterWaveButton {...fwConfig} />
    </div>
  );
}
